import { useState } from "react";
import { Link } from "react-router-dom";
import {
  ABOUTUS_URL_LOCAL,
  BASE_URL,
  CONTACTUS_URL_LOCAL,
  FAQ_URL_LOCAL,
  HOME_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
} from "../../../utility/BaseUrl";

const MenuOffcanvasComponent = ({ about, category, setting }) => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleCategory, setToggleCategory] = useState(false);
  const handelMenuToggle = () => {
    setToggleMenu(!toggleMenu);
  };
  return (
    <>
      <div className="d-block d-lg-none">
        <div className="header-mobile pt-half">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-6">
                <nav className="d-lg-none" role="navigation">
                  <div
                    className={
                      "offcanvas" + (toggleMenu ? " offcanvas-expanded" : "")
                    }
                  >
                    <div className="offcanvas-overlay" />
                    <button
                      type="button"
                      onClick={handelMenuToggle}
                      className="navbar-toggler"
                    >
                      <span className="fa fa-bars align-middle" />
                      {/* منوی وب‌سایت */}
                    </button>
                    <div id="offcanvas-107738553" className="offcanvas-sidebar">
                      <div className="offcanvas-header">
                        <a className="offcanvas-brand" href="javascript:;">
                          {setting[0] ? setting[0].site_main_title : null}
                        </a>
                        <button
                          type="button"
                          onClick={handelMenuToggle}
                          className="offcanvas-close"
                        >
                          <i
                            className="fa fa-times"
                            style={{ color: "#000" }}
                          />
                        </button>
                      </div>
                      <ul className="offcanvas-nav" role="menu">
                        <li
                          className={
                            "offcanvas-nav-item" +
                            (toggleCategory
                              ? " offcanvas-nav-item-expanded"
                              : "")
                          }
                        >
                          <span className="offcanvas-nav-link">دسته بندی</span>
                          <button
                            type="button"
                            onClick={() => {
                              setToggleCategory(!toggleCategory);
                            }}
                            className="offcanvas-nav-toggle"
                          >
                            <i className="fa offcanvas-nav-toggle-icon" />
                          </button>
                          <ul
                            className="offcanvas-nav-subset offcanvas-nav-subset-1"
                            role="menu"
                          >
                            {category
                              ? category.map((item, index) => {
                                  const queryParams = new URLSearchParams({
                                    category: item.title,
                                  }).toString();

                                  return (
                                    <li
                                      key={index}
                                      className="offcanvas-nav-item "
                                    >
                                      <Link
                                        to={
                                          SEARCH_PRODUCT_URL_LOCAL +
                                          `?${queryParams}`
                                        }
                                        onClick={handelMenuToggle}
                                        className="offcanvas-nav-link"
                                      >
                                        {item.title}
                                      </Link>
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                        </li>
                        <li className="offcanvas-nav-item">
                          <Link
                            to={FAQ_URL_LOCAL}
                            className="offcanvas-nav-link"
                          >
                            پرسش های متداول
                          </Link>
                        </li>
                        <li className="offcanvas-nav-item ">
                          <Link
                            to={CONTACTUS_URL_LOCAL}
                            className="offcanvas-nav-link"
                          >
                            ارتباط با ما
                          </Link>
                        </li>
                        <li className="offcanvas-nav-item">
                          <Link
                            to={ABOUTUS_URL_LOCAL}
                            className="offcanvas-nav-link"
                          >
                            درباره ما
                          </Link>
                        </li>
                      </ul>
                      {about && about[0] ? (
                        <div
                          className="header-contact d-inline-block ml-2 mt-3"
                          style={{ direction: "rtl", float: "left" }}
                        >
                          <span className="align-middle">
                            {about[0].site_phone}
                          </span>
                          <img
                            className="header-contact-icon align-middle"
                            src="/themes/custom-1a98/images/phone.png"
                            alt={about[0].site_phone}
                            title={about[0].site_phone}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </nav>
              </div>
              <div className="col-6">
                <div className=" d-flex justify-content-end">
                  {setting[0] ? (
                    <>
                      <h1 className="header-sitename">
                        فروشگاه اینترنتی {setting[0].site_main_title}
                      </h1>
                      <Link className="d-block text-center" to={HOME_URL_LOCAL}>
                        <img
                          src={BASE_URL + setting[0].site_logo}
                          alt={setting[0].logo_alt}
                          title={setting[0].logo_title}
                          style={{ maxWidth: "30px" }}
                          className="header-logo img-fluid"
                        />
                      </Link>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuOffcanvasComponent;
